import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsCriticality, PmsCriticality } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsCriticality>
    useData={usePmsCriticality}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
